import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { applyStoredTheme } from "./components/ThemeToggle";
import { ToastProvider } from "./components/ui";
import { setupKeyboardAssist, setupNativeShell } from "./lib/platform";
import { RouterProvider } from "./router/router";
import "./styles/global.css";
import "./styles/layout.css";
import "./styles/training.css";
import "./styles/strength.css";
import "./styles/run.css";
import "./styles/activities.css";
import "./styles/performance.css";
import "./styles/communication.css";
import "./styles/body.css";
import "./styles/help.css";
import "./styles/tickets.css";
import "./styles/app.css";

applyStoredTheme();
setupNativeShell();
setupKeyboardAssist();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </RouterProvider>
  </StrictMode>,
);
